'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var brcast = {};

exports.__exports = brcast;
